import { render, staticRenderFns } from "./EditShippingServiceProviderComponent.vue?vue&type=template&id=47e85d04&"
import script from "./EditShippingServiceProviderComponent.vue?vue&type=script&lang=js&"
export * from "./EditShippingServiceProviderComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports